import { render, staticRenderFns } from "./SchemaPresetDropdown.vue?vue&type=template&id=9125b17c"
import script from "./SchemaPresetDropdown.vue?vue&type=script&lang=ts"
export * from "./SchemaPresetDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports